/**
 * Concatenates a list of user names in a readible way from an Array of users
 * Note: to be used as a `reduce` function.
 *
 * @param {String} names List of names up to that point in the iteration
 * @param {Object} user User
 * @param {Number} index Index up to that point in the iteration
 * @param {Array<Object>} users List of users to concatenated their names
 *
 * @return {String}
 */
function concatNamesList({ labelAnd = "and" } = {}) {
    return function(names, user, index, users) {
        names += user.firstname;
        if (user.lastname) names += ` ${user.lastname}`;

        if (index < users.length - 2) {
            names += ", ";
        } else if (index === users.length - 2) {
            names += " " + labelAnd + " ";
        } else {
            names += " ";
        }

        return names;
    };
}

export default { concatNamesList };
export { concatNamesList };
